import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { useUrlPagination } from '../../shared/hooks/useUrlPagination.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import { EmptyState } from '../../shared/ui/EmptyState';
import { Plus, Tags } from 'lucide-react';

const PAGE_SIZE = 5;
const BASE_PATH = '/shop/products/categories';

const CategoriesOfProductPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { page, offset, pageSize, setPage } = useUrlPagination(PAGE_SIZE);
  // Применённый поиск — в URL, в поле — черновик
  const query = searchParams.get('q') || '';
  const [categories, setCategories] = useState({});
  const [searchValue, setSearchValue] = useState(query);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => setSearchValue(query), [query]);

  useEffect(() => {
    let cancelled = false;
    apiRequests.products.getCategories(pageSize, offset, query).then((res) => {
      if (!cancelled) setCategories(res);
    });
    return () => {
      cancelled = true;
    };
  }, [page, query, reloadKey]);

  const handleSearch = () => {
    const search = searchValue.trim();
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (search) params.set('q', search);
      else params.delete('q');
      params.delete('page');
      return params;
    });
  };

  const handleDelete = (id) => {
    apiRequests.products.deleteCategory(id).then(() => {
      if (categories.items?.length === 1 && page > 1) setPage(page - 1);
      else setReloadKey((k) => k + 1);
    });
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink={`${BASE_PATH}/create`}
      />

      <div className="mb-3">
        {categories.items?.length === 0 ? (
          query ? (
            <EmptyState
              icon={Tags}
              variant="search"
              title="Категория не найдена"
              description={`По запросу «${query}» категорий магазина нет. Проверьте написание или сбросьте поиск.`}
            />
          ) : (
            <EmptyState
              icon={Tags}
              title="Категорий пока нет"
              description="Категория нужна каждому товару: по ней покупатели фильтруют витрину магазина."
              action={{ label: 'Добавить категорию', to: `${BASE_PATH}/create`, icon: Plus }}
            />
          )
        ) : (
          categories.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[{ label: 'Создано', value: dateToString(item.createdAt) }]}
              editLink={`${BASE_PATH}/${item.id}`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        page={page}
        total={categories.totalCount}
        pageSize={pageSize}
        onPageChange={setPage}
      />
    </>
  );
};

export default CategoriesOfProductPage;
